<template>
    <gj-modal
            v-bind="$attrs"
            v-on="$listeners"
            size="700XAuto"
            :visible.sync="modalVisible"
            :confirmLoading="confirmLoading"
            @cancel="cancel"
            @close="cancel"
            @confirm="confirm">
        <span slot="header">过滤常用词</span>
        <el-form :model="form" :rules="rule" ref="form" slot="content">
            <el-form-item prop="keywords">
                <gj-textarea
                        v-model="form.word"
                        :styles="{ height: '300px'}"
                >
                </gj-textarea>
                <el-row>{{ description }}</el-row>
            </el-form-item>
        </el-form>
    </gj-modal>
</template>

<script>
    import { modalMixIn } from "@/minxins";

    export default {
        name: "filter-word",
        props: {
            // 分隔符
            separator: {
                type: String,
                default: ';'
            },
            // 更新关键词
            fnUpdate: {
                type: Function,
                default: () => Promise.resolve()
            },
            // 查询关键词
            fnView: {
                type: Function
            },
            // 是否只读
            readonly: {
                type: Boolean,
                default: false
            },
            // 是否禁用
            disable: {
                type: Boolean,
                default: false
            },
            // 描述
            description: {
                type: String,
                default: '不同词语间请用分号隔开;词语不区分大小写'
            }
        },
        mixins: [ modalMixIn ],
        data () {
            return {
                form: {
                    id: '',
                    word: ''
                },
                rule: {
                    word: [{
                        validator: (rule, value, callback) => {
                            callback()
                        },
                        message: '格式不正确',
                        trigger: 'blur'
                    }]
                }
            }
        },
        created () {
            this.getKeywords()
        },
        methods: {
             cancel () {
                 this.modalVisible = false
             },
            confirm () {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        const fnUpdate = this.fnUpdate.bind(this, this.form)
                        fnUpdate().then(res => {
                            this.$gjMessage.success('保存成功')
                            this.$emit('complete')
                            this.cancel()
                            this.$gjDestroy()
                        })
                    }
                })
            },
            /**
             * 查询词云过滤词
             */
            getKeywords () {
                const fnView = this.fnView
                if (fnView && typeof fnView === 'function') {
                    fnView().then(res => {
                        this.form.id = res.id
                        this.form.word = res.word
                    })
                }
            }
        },
    }
</script>

<style scoped>

</style>
